import React, { useCallback, useEffect, useRef, useState } from "react";
import CommonLayout from "../../../../Components/CommonLayout/CommonLayout.jsx";
import { useFetchAll } from "../../../../custom/FetchApiHook.jsx";
import BasicTable from "../../../../Components/CommonTable/BasicTable/BasicTable.jsx";
// import { columns, searchBy } from "../../../../service/TaxMasterService.js";
import { MasterApi, UnitApi } from "../../../../App/api/setting.js";
import { useSelector } from "react-redux";
import UnitMeasurementModal from "./UnitMeasurementModal.jsx";
import { Button } from "primereact/button";
// import { DeleteModal } from "../../../../custom/modal/delteModal.jsx";
import style from "../master.module.css";
import { columns, searchBy } from "./UnitMasterService.js";

const UnitOfMaster = () => {
  const [addUnitModel, setAddUnitModal] = useState(false);
  const [selected, setSelectedData] = useState(null);
  const { value: allUnitData, fetchAllData } = useFetchAll(() =>
    UnitApi.master.getAllUnitMaster()
  );
  const UnitData = allUnitData?.data;

  useEffect(() => {
    fetchAllData();
  }, []);

  console.log("allUnitData:", UnitData);

  const handleClearFilter = () => {
    // setPagination({
    //   page: 1,
    //   limit: 5,
    //   sortOrder: "desc",
    //   filter: {},
    // });
  };
  const handleSearch = useCallback((s) => {
      // setSearch(s);
    }, []);
  
    const debouncedSearch = useCallback(
      () => {
        // if (debounceTimeout.current) {
        //   clearTimeout(debounceTimeout.current);
        // }
        // debounceTimeout.current = setTimeout(() => {
        //   handleSearch(s);
        // }, 1500);
      },
      [handleSearch]
    );
  const handleCellClick = (cell, field = "") => {
    if ((field = "_id")) {
      setAddUnitModal(true);
      setSelectedData(cell);
      console.log("selected:", cell);
      // console.log("field:", field);
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      // console.log("Paginator Clicked", e);
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      //   handlePagination && handlePagination(data);
    }
  };

  return (
    <div className="p-5">
      <CommonLayout />
      <BasicTable
        data={UnitData}
        handleClearFilter={handleClearFilter}
        handleSearch={debouncedSearch}
        onPaginatorClick={onPaginatorClick}
        // paginatorData={{
        //   filters: null,
        //   first: 0,
        //   multiSortMeta: [],
        //   page: allTaxData?.data?.page || 1,
        //   rows: allTaxData?.data?.limit || 5,
        //   totalPages: allTaxData?.data?.totalPages || 1,
        //   totalCount: allTaxData?.data?.totalCount || 1,
        // }}
        selectedData={selected}
        columns={columns}
        // handleFilter={handleFilter}
        handleCellClick={handleCellClick}
        SearchBy={searchBy}
        // filters={filters}
        // WeekRange={false}
        button_name="Add"
        handleButton={() => {
          setAddUnitModal(true);
          //   setTaxDataClicked(null);
        }}
      />
      {addUnitModel && (
        <UnitMeasurementModal
        data={selected}
          isOpen={addUnitModel}
          onClose={() => setAddUnitModal(false)}
          // data={taxDataClicked}
          fetchAllData={fetchAllData}
        />
      )}
    </div>
  );
};

export default UnitOfMaster;
